import { supabase } from './supabaseClient';

export interface LessonProgress {
  lesson_id: string;
  watched: boolean;
  liked: boolean | null;
}

const getAuthenticatedUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error || !user) {
    throw new Error('Usuário não autenticado');
  }
  return user;
};

export const newProgressService = {
  async updateProgress(lessonId: string, { watched, liked }: { watched?: boolean; liked?: boolean | null }) {
    try {
      const user = await getAuthenticatedUser();
      
      const { error } = await supabase
        .from('lesson_progress')
        .upsert({
          user_id: user.id,
          lesson_id: lessonId,
          ...(watched !== undefined ? { watched, last_viewed_at: watched ? new Date().toISOString() : null } : {}),
          ...(liked !== undefined ? { liked } : {}),
          updated_at: new Date().toISOString()
        }, {
          onConflict: 'user_id,lesson_id'
        });

      if (error) {
        console.error('Erro ao salvar progresso:', error);
        throw error;
      }
    } catch (error) {
      console.error('Erro ao atualizar progresso:', error);
      throw error;
    }
  },

  async getProgress(lessonId: string): Promise<LessonProgress | null> {
    try {
      const user = await getAuthenticatedUser();
      
      const { data, error } = await supabase
        .from('lesson_progress')
        .select('lesson_id, watched, liked')
        .eq('user_id', user.id)
        .eq('lesson_id', lessonId)
        .single();

      if (error) {
        if (error.code === 'PGRST116') {
          return null;
        }
        console.error('Erro ao carregar progresso:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro ao carregar progresso:', error);
      throw error;
    }
  },

async getBatchProgress(lessonIds: string[]): Promise<Record<string, boolean>> {
  try {
    const user = await getAuthenticatedUser();      const { data, error } = await supabase
        .from('lesson_progress')
        .select('lesson_id, watched')
        .eq('user_id', user.id)
        .in('lesson_id', lessonIds);

      if (error) {
        console.error('Erro ao carregar progresso em lote:', error);
        throw error;
      }

      console.log('Dados retornados:', data);
      const resultado: Record<string, boolean> = {};
      lessonIds.forEach(id => {
        const progress = data?.find(p => p.lesson_id === id);
        resultado[id] = progress?.watched || false;
      });
      console.log('Resultado processado:', resultado);

      return resultado;
    } catch (error) {
      console.error('Erro ao carregar progresso em lote:', error);
      return {};
    }
  }
};
